interface Props {
  errors?: string | string[];
  showTop?: boolean;
  displayRows?: boolean;
}

function InlineValidation({ errors, showTop, displayRows }: Props) {
  if (!errors) return null;

  const errorList = Array.isArray(errors)
    ? errors
    : typeof errors === 'string'
      ? errors.split(',')
      : [];

  console.log(errorList);

  return (
    <>
      {!showTop && (
        <div className={`${displayRows ? 'flex flex-row gap-1' : ''}`}>
          {errorList.map((error, index, arr) => (
            <p key={index} className="text-sm text-red-500 mt-2.5">
              {displayRows
                ? `${error}${index !== arr.length - 1 ? ',' : ''}`
                : error}
            </p>
          ))}
        </div>
      )}

      {showTop && <p className="text-sm text-red-500 mt-2.5">{errorList[0]}</p>}
    </>
  );
}

export default InlineValidation;
